import { Component, Input, OnInit } from '@angular/core';
import { CommonDataService } from '../../services/common-data.service';

@Component({
  selector: 'app-location-breadcrumb',
  templateUrl: './location-breadcrumb.component.html'
})
export class LocationBreadcrumbComponent implements OnInit {

  constructor(
    public commonDataService: CommonDataService
  ) { }

  @Input() printPreview?: boolean = false;
  @Input() isShowAllInOnePage?: boolean = false;
  currentParagraph: string;
  arrowRightDown: boolean = false;
  crumbData: any[];

  ngOnInit(): void {
    this.commonDataService.navDataContentPage.subscribe(data => {
      if (this.printPreview && this.isShowAllInOnePage) {
        this.crumbData = data.slice(0, 1);
      }
      else if (this.printPreview) {
        this.crumbData = data.slice(0, data.length - 1);
      }
      else {
        this.crumbData = data;
      }
    })
    this.commonDataService.currentParagraph.subscribe(data => {
      this.currentParagraph = data;
      this.arrowRightDown = false;
      if (data == "") {
        this.arrowRightDown = true;
      }
    })
  }
}
